var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #3b66b0;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.3,11.2h-1.3l-8.7-3.8c.2-.4.4-1.1.4-1.6s-.4-.9-.9-.9-.9.6-.9.9,0,.7-.3,1l-1.3-.6h-.7l-.5.2c0-.2,0,.3,0-.6s.7-1.6,1.5-1.6.9-.4.9-.9V.9c0-.5-.4-.9-.9-.9s-.9.4-.9.9v1.6c-1.4.4-2.4,1.7-2.4,3.2s.1.9.3,1.3l-9.5,4.1h-1.3c-1.5.1-2.7,1.3-2.7,2.8v15.6c0,1.5,1.2,2.7,2.7,2.7h26.6c1.5,0,2.7-1.2,2.7-2.7v-15.6c0-1.5-1.2-2.7-2.7-2.7ZM14.7,8.3c.5.4,1.3.6,1.8.6s1-.1,1.4-.3h.1l5.7,2.4h-15.2l6.2-2.7ZM30.3,29.3c0,.5-.4.9-.9.9H2.7c-.5,0-.9-.4-.9-.9v-15.6c0-.5.4-.9.9-.9h26.7c.5,0,.9.4.9.9v15.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.6,28.5h24.9v-13.8H3.6v13.8ZM24.5,16.9c0-.5.4-.9.9-.9s.9.4.9.9v9.5c0,.5-.4.9-.9.9s-.9-.4-.9-.9v-9.5ZM19.8,16.9c0-.5.4-.9.9-.9s.9.4.9.9v9.5c0,.5-.4.9-.9.9s-.9-.4-.9-.9v-9.5ZM15.1,16.9c0-.5.4-.9.9-.9s.9.4.9.9v9.5c0,.5-.4.9-.9.9s-.9-.4-.9-.9v-9.5ZM10.4,16.9c0-.5.4-.9.9-.9s.9.4.9.9v9.5c0,.5-.4.9-.9.9s-.9-.4-.9-.9v-9.5ZM5.7,16.9c0-.5.4-.9.9-.9s.9.4.9.9v9.5c0,.5-.4.9-.9.9s-.9-.4-.9-.9v-9.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainer);
export default __webpack_public_path__ + "static/media/container.7285d54d4246f8f7492d86061bea2227.svg";
export { ForwardRef as ReactComponent };